module.exports = __webpack_public_path__ + "img/Watney4.8935af57.svg";